import NotificationDropdown from '@/components/navbar/top/notification/NotificationDropdown';
import ProfileDropdown from '@/components/navbar/top/ProfileDropdown';
import ThemeControlDropdown from './ThemeControlDropdown';
import NineDotMenu from './NineDotMenu';
import TabHelper from './TabHelper';
import CustomToggle from './CustomToggle';
import ExpandButton from './ExpandButton';
import WalletsNavGroup from '../../../app/Wallet/components/WalletsNavGroup';
import { Dropdown, Nav } from 'react-bootstrap';
import { MdAttachMoney, MdCall, MdDashboard, MdWhatsapp } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { useGetUserInfoQuery } from '@/app/common/api/authApi';
import { getCookie } from '@/app/common/utils/cookieService';
import type { IconType } from 'react-icons';



type NavMenuItem = {
  title: string;
  icon: IconType;
  to?: string;
  onClick?: () => void;
};

const TopNavRightSideNavItem = () => {
  const { isLoading } = useGetUserInfoQuery();
  const token = getCookie((import.meta as any).env.VITE_ACCESS_TOKEN_NAME);

  const menuItems: NavMenuItem[] = [
    {
      title: 'پیشخوان',
      to: '/',
      icon: MdDashboard
    },
    {
      title: 'قیمت',
      to: '/prorogate-or-upgrade/',
      icon: MdAttachMoney
    },
    {
      title: 'تماس مستقیم',
      icon: MdCall,
      onClick: () => {
        window.location.href = 'tel:09300208048';
      }
    },
    {
      title: 'تماس در واتس آپ',
      icon: MdWhatsapp,
      onClick: () => {
        window.open('https://wa.me/989300208048', '_blank');
      }
    }
  ];

  return (
    <Nav
      navbar
      className="navbar-nav-icons ms-auto gap-2 flex-row align-items-center"
      as="ul"
    >
      <Dropdown>
        <Dropdown.Toggle as={CustomToggle} id="dropdown-basic"></Dropdown.Toggle>
        <Dropdown.Menu className="mt-2">
          {menuItems.map(item => (
            item.to ? (
              <Dropdown.Item
                key={item.title}
                as={Link}
                to={item.to}
                className="d-flex align-items-center py-2 rounded-2 link-600"
              >
                <item.icon fontSize={17} className="me-2" />
                <span>{item.title}</span>
              </Dropdown.Item>
            ) : (
              <Dropdown.Item
                key={item.title}
                onClick={item.onClick}
                className="d-flex align-items-center py-2 rounded-2 link-600"
              >
                <item.icon fontSize={17} className="me-2" />
                <span>{item.title}</span>
              </Dropdown.Item>
            )
          ))}
        </Dropdown.Menu>
      </Dropdown>
      <TabHelper />
      <span className="d-md-block d-none">
        <ExpandButton />
      </span>
      <ThemeControlDropdown />
      {!isLoading && <NotificationDropdown token={token} />}
      <div className="d-flex align-items-center gap-2">
        <WalletsNavGroup />
        <span className="d-none d-md-inline-flex align-items-center gap-2">
          {/* جداکننده کمرنگ بین کیف پول و پلتفرم‌ها */}
          <span
            aria-hidden="true"
            className="d-inline-block align-middle ms-1"
            style={{
              width: 1,
              height: 20,
              backgroundColor: 'var(--falcon-gray-300)',
              opacity: 0.6
            }}
          />
          <NineDotMenu />
        </span>
      </div>
      <div className="d-flex align-items-center">
        <ProfileDropdown />
      </div>
    </Nav>
  );
};

export default TopNavRightSideNavItem;
